import jsonPost from '../util/jsonPost';
import { POST_LOG_URL } from './EnvironmentVariables.config';

export const DURATION = 250;

// Date/Time formats
export const INPUT_DATE_FORMAT = 'DD/MM/YYYY';
export const INPUT_DATE_FORMAT_SHORT = 'DD/MM/YY';
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'Do MMMM Y';
export const DISPLAY_DATE_FORMAT_LONG_WITH_DAY = 'dddd D MMMM YYYY';
export const DISPLAY_TIME_FORMAT = 'HH:mm';
export const DISPLAY_DATE_FORMAT_LONG = 'D MMMM YYYY';

export const MINIMUM_DATE = '01/01/1900';

export const MINIMUM_ADULT_AGE = 18;

export const UK_DIAL_CODE = '44';

export const DOC_TYPE_ALIAS = {
  TOUR: 'tour',
  NEWS_ARTICLE: 'newsArticlePage',
};

/* createLogData maps our data to the shape the server requires.,
We must enter details as params and include them as curly braces in the body
for this information to show. See example below:
{
  "logLevel": 2,
  "ModuleName": "Postman",
  "action": "LogInformation",
  "body": "Test log information message with test param1: {param1}; Test Param 2 {param2}",
  "params": [ { "orderId": 123 }, { "transactionKey": "1234" } ]
}
*/
export const createLogData = ({ logLevel, moduleName, action, baseBody, additionalData }) => {
  const params = [];
  const dynamicBodyParts = [];

  // Process additionalData to create params and dynamic body parts
  Object.entries(additionalData).forEach(([key, value]) => {
    params.push({ [key]: value });
    dynamicBodyParts.push(`${key}: {${key}}`);
  });

  // Combine base body with dynamic parts
  const body = `Message:\u00A0${baseBody}.\u00A0Params:\u00A0${dynamicBodyParts.join('; ')}`;

  return {
    logLevel,
    ModuleName: moduleName,
    action,
    body,
    params,
  };
};

export const logToCAS = async (logData) => {
  // Post the log data to the logging endpoint
  await jsonPost(
    POST_LOG_URL,
    logData,
    () => console.info('Log posted:', logData),
    (error) => console.error('Error posting log:', error)
  );
};

export const logToCASSuccess = async (logSuccessData) => {
  // Post the log data to the logging endpoint
  await jsonPost(
    POST_LOG_URL,
    logSuccessData,
    () => console.log('Log posted:', logSuccessData),
    (error) => console.error('Error posting log:', error)
  );
};

// String for logging purposes only to identify the file in CAS
export const RedirectModulePathName =
  'Src\\MikeBurton.Website.FED\\app\\components\\render\\Redirect.jsx';

export const DEFAULT_COUNTRY_NAME = 'United Kingdom';

export const cleanupCountryName = (countryName) => countryName.replace(/\s*\([^)]*\)\s*/g, '');
